'use strict';

var $ = require('jquery');
var intlPageSetup = require('../utils/intlPageSetup');
var disablingLayer = require('vhi-ui-framework/src/main/js/panels/disablingLayer');
var form2js = require('form2js');
var validation = require('shared/scripts/modules/forms/validation');
var createValidator = require('shared/scripts/modules/forms/validation').createValidator;
var EmployeeGroupSelect = require('shared/scripts/modules/EmployeeGroupSelect');
var StartDatePicker = require('shared/scripts/modules/StartDatePicker');
var intlStateService = require('../services/intlStateService');
var transactionStageService = require('../services/transactionStageService');
var urls = require('shared/scripts/modules/utils/urls');
var breadCrumb = require('../utils/breadCrumb');
var renewalSuspended = require('../utils/renewalSuspended');
var inputHelper = require('shared/scripts/modules/forms/inputHelper');
var thisPageAnalytics = require('./join-details-start-analytics');

require('shared/scripts/modules/forms/commonValidations');

var pageValidator;
var productType = 'GLOBAL';
var formId = 'detailsStartForm';

function init() {
    var model;
    var transactionStage = transactionStageService.getTransactionStage();
    var startDatePicker;

    return $.when(intlStateService.getTransactionState(), intlPageSetup.init())
        .then(function (transactionStateModel) {
                model = transactionStateModel;

                pageValidator = createPolicyPageValidator();

                startDatePicker = new StartDatePicker({
                    id: 'policyStartDate',
                    mountOn: 'policyStartDateRow',
                    mountImmediateley: false,
                    inputName: 'policyDate',
                    i18nContext: 'details.start.',
                    supportTextVisible: true,
                    supportTexti18nPostfix: renewalSuspended.getSupportTexti18nPostfix,
                    supportTextStyleClass: renewalSuspended.getSupportTextStyleClass
                });

                var employeeGroupsPromise = new EmployeeGroupSelect({
                    id: 'employeeGroup',
                    mountOn: 'employeeGroupRow',
                    onChange: onEmployeeGroupChange,
                    renderSingleGroup: false,
                    readOnly: false,
                    inputName: 'employeeGroup',
                    i18nContext: 'details.start.'
                });
                return employeeGroupsPromise;
        })
        .then(function(employeeGroupComponent) {
            var availableGroupIds = employeeGroupComponent.getAvailableGroups();
            var employeeGroupId = model.employeeGroup;

            if (availableGroupIds.length === 1) {
                employeeGroupId = availableGroupIds[0];
            }
            if (employeeGroupId) {
                employeeGroupComponent.setValue(employeeGroupId);
                setEmployeeGroup(employeeGroupId);
            }
        })
        .then(function () {
            $('.journey-content').localize();
            disablingLayer.hideDisablingLayer();
            form2js.js2form(formId, model);
            validateForm();
            initBreadCrumb();
            thisPageAnalytics.addAnalyticsHandlers();
        });

    function initBreadCrumb() {
        breadCrumb.init({
            sessionTransactionStage: transactionStage
        });
    }

    function onEmployeeGroupChange(employeeGroupId) {
        $('#policyStartDate').val('');
        $('#policyStartDate').prop('disabled', true);
        setEmployeeGroup(employeeGroupId);
    }

    function setEmployeeGroup(employeeGroupId) {
        model.employeeGroup = employeeGroupId;
        if (employeeGroupId) {
            return startDatePicker.render(employeeGroupId, productType);
        } else {
            $('.policy-start-date-support-text').hide();
            startDatePicker.setValue('');
            return $.Deferred().resolve();
        }
    }

    function createPolicyPageValidator() {
        return createValidator($("#" + formId), {
            submitHandler: next,
            onkeyupCallback: validateForm,
            onfocusoutCallback: onFocusOutValidateForm,
        });
    }

    function validateForm() {
        $('#next').toggleClass("primary-button--inactive", !(validation.isValid('#' + formId)));
    }

    function onFocusOutValidateForm() {
        inputHelper.trimElementValue($('#firstName'));
        inputHelper.trimElementValue($('#lastName'));

        validateForm();
    }

    function next(form) {
        var formInput = form2js.form2js(formId);
        var mergedModel = $.extend(true, {}, model, formInput);
        intlStateService.postTransactionState(mergedModel)
            .then(function() {
                transactionStageService.setTransactionStage('POLICY');
                urls.navigateToUrl('/intgroups/join-details-policy?transaction-id=' + model.transactionId);
            })
            .fail(validation.renderServerErrors('#' + formId));
    }
}

module.exports.init = init;



//////////////////
// WEBPACK FOOTER
// ./src/international/scripts/pages/join-details-start.js
// module id = xGcg
// module chunks = 2